import React from "react";
import TabWithPanel from "@components/tab/TabWithPanel";
import {
  SavedBrandList,
  SavedProductList,
  SavedSellerList,
} from "@pages/saved/_components";
import { useTranslation } from "react-i18next";

const Saved = () => {
  const { t } = useTranslation();

  const savedTabList = [
    {
      key: "1",
      label: t("관심 상품"),
      children: <SavedProductList />,
    },
    {
      key: "2",
      label: t("관심 브랜드"),
      children: <SavedBrandList />,
    },
    {
      key: "3",
      label: t("관심 셀러"),
      children: <SavedSellerList />,
    },
  ];

  return <TabWithPanel item={savedTabList} defaultValue="1" underline />;
};

export default Saved;
